jQuery(function($) {
  
  	// Refresh Yotpo Widgets (for AJAX-injected recommended products)
    setTimeout(function() {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    }, 1000);

    // Redirect 5/27/21
    if (window.location.host == 'mmeslds8ff1h74a3-41086681253.shopifypreview.com' &&
      window.location.href.indexOf('shop-20-off') > -1
    ) { 
      window.location = 'https://lasuiteskincare.com/collections/shop-20-off?utm_campaign=05.27.21%20-%2020%25%20OFF%20Sunscreen%20%28R44XMw%29&utm_medium=email&utm_source=All%20Subscribers';
    }
  
  
    // Easy Live Chat link
    $('a[href="#live-chat"]').click(function(e) {
      e.preventDefault();
      tidioChatApi.open();
    })
    
    // All Buttons on homepage are block-styled
    // $('body.template-index .font--block-link').each(function() {
    //   var $this = $(this);
    //   var $a = $this.children('a').first();
  
    //   $this.removeClass('font--block-link');
    //   $a.addClass('font--button font--button-outline');
    // });
    // $('#shopify-section-1519177213210 .font--button').addClass('white');
    
    // Product page customizations
    $('.row.social-share').insertAfter('#shopify-section-framework--product-recommendations');
    
    // Disable ReCharge on some variants
    $('body').on('change click', '.single-option-selector', function() {
  
      var variantID = $('#variant-listbox')[0].value;
      
      var variantsNotAllowedInASubscription = [
        '36210298486949', // Botanical Brightening Pads 2%
        '36210298519717'  // Botanical Brightening Pads 4%
      ];
      
      if (variantsNotAllowedInASubscription.indexOf(variantID) != -1) {
        $('.rc_radio__onetime').click();
        $('#rc_container').hide();
      } else {
        $('#rc_container').show();
      }
      
    });
    $(document).ready(function() {
      setTimeout(function() {
        $('.single-option-selector').trigger('change');
      }, 2000);
    });
    
    
    // Switch 'Out of Stock' notification on items not purchasable
    // without calling La Suite
    var $OOSNotification = $('.product-unavailable > p:first-of-type');
    var defaultOOSText = $OOSNotification.html();
    var callOOSText = 'This product requires a consultation to purchase. Please call us at <a style="text-decoration:underline" href="tel:2038617338">203-861-7338</a> for a consultation to review product protocol before purchasing 4% Hydroquinone.';
    $('body').on('change click', '.single-option-selector', function() {
      
      var variantID = $('#variant-listbox')[0].value;
      var variantsRequiringACall = [
        '36210298519717'  // Botanical Brightening Pads 4%
      ];
  
      setTimeout(function() {
        if (variantsRequiringACall.indexOf(variantID) != -1) {
          $OOSNotification.html(callOOSText);
          $('.product-unavailable > form').hide();
        } else {
          $OOSNotification.html(defaultOOSText);
          $('.product-unavailable > form').show();
        }
      }, 10);
      
    });
    
    
    // Product Accordion  
    var acc = document.getElementsByClassName("accordion-header");
    var content = document.getElementsByClassName('accordion-content');
  
    if (acc.length > 0) {
        acc[0].classList.add("active");
          content[0].classList.add("show");



        for (var i = 0; i < acc.length; i++) {
            acc[i].onclick = function() {
                var setClasses = !this.classList.contains('active');
                setClass(acc, 'active', 'remove');
                setClass(content, 'show', 'remove');

                if (setClasses) {
                    this.classList.toggle("active");
                    this.nextElementSibling.classList.toggle("show");
                }
            }
        }

        function setClass(els, className, fnName) {
            for (var i = 0; i < els.length; i++) {
                els[i].classList[fnName](className);
            }
        }

    };

          
    // Clear search query
    $('.search--clear').click(function(){
      $('input.search--textbox').val("");
    });
     
    // Clears query when modal is closed
    $('.search--close').click(function(){
      $('input.search--textbox').val("");
    });
 

    // Required Signature toggle 
    $('body').on('click', '.required-signature .required-insurance-input', function(){
      $('.required-signature .switch').toggleClass('checked');
    });


      /*
      $('.cart--root .add-to-cart-btn button').click(function() {
        var variantID = $(this).attr('data-variant-id');
        console.log('test we want to add variantID:', variantID);
        upsellAddToCart(variantID, 1);
      });
      */

      initCustomDuties();

      $(window).on('theme.cart.update-complete', initCustomDuties);
});

// Render Custom Duties
function loadCustomDutiesCountry(country) {
  if (country != 'US') {
    // Add fake checkout button to validate duties
    var dutiesButton = $('#duties-checkout-button');
    var checkoutButton = $('button[name="checkout"]');
    var dutiesError = $('#duties-error');
    if (!dutiesButton.length) {
      dutiesButton = $('<button/>').attr('id', 'duties-checkout-button').appendTo('.cart--checkout-button').html('Checkout');
      dutiesButton.on('click', function(e) {
        e.preventDefault();
        
        if (!dutiesError.length) {
          dutiesError = $('<div/>').attr('id', 'duties-error').addClass('error').insertAfter('.custom-duties-checkbox').html('You must agree that you are responsible for paying customs duties and taxes.');
        } else {
          dutiesError.show();
        }
      });
    }
    if ($('.custom-duties-checkbox-input').is(":checked")) {
      dutiesButton.hide();
      checkoutButton.show();
    } else {
      dutiesButton.show();
      checkoutButton.hide();
    }
    // $('.custom-duties-checkbox-input').prop('checked', true);
    //$('.custom-duties-checkbox .cd-switch').addClass('checked');
    $('.custom-duties-checkbox-input').on('change', function() {
      var checkbox = $(this);
      var label = checkbox.parents('.cd-switch').first();
      
      if (checkbox.is(':checked')) {
        label.addClass('checked');
        dutiesButton.hide();
        dutiesError.hide();
        checkoutButton.show();
      } else {
        label.removeClass('checked');
        dutiesButton.show();
        checkoutButton.hide();
      }
    });
  } else {
    $('.custom-duties-checkbox').hide();
  }
    console.log(country + "aaa");

}

function initCustomDuties() {
  if ($('.template-cart').length) {
    var country = sessionStorage.getItem("country");
    if (country === null) {
      jQuery.getJSON('/browsing_context_suggestions.json', function(info) {
          country = info.detected_values.country.handle;
          sessionStorage.setItem('country', country);
          loadCustomDutiesCountry(country);
        });
    } else {
      loadCustomDutiesCountry(country);
    }
  }
}
  	
// Add to cart for Cart Page
function upsellAddToCart(variant_id, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: qty,
      id: variant_id
    },
    dataType: 'json',
    success: function (itemData) {
      console.log('success');
      window.location.href = '/cart'; // TODO: make mini-cart refresh rather than redirect to cart
    },
    error: function (XMLHttpRequest) {
      console.log(XMLHttpRequest.responseText);
    }
  });
}
function productItemAddtoCart(variant_id, qty) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: qty,
      id: variant_id
    },
    dataType: 'json',
    success: function (itemData) {
      theme.partials.Cart.updateAllHtml(function() {
        console.log(theme.partials.Cart.getHtml());
        $('.cart--root').attr('data-has-items', 'true');
        $('[data-off-canvas--open="right-sidebar"]').first().trigger('click');
      });
      console.log('success', itemData);

    },
    error: function (XMLHttpRequest) {
      console.log(XMLHttpRequest.responseText);
    }
  });
}
// Category Collection description
var textHolder = $(".plp-description");
var readMore = $('#more');

function toggleText() {
  textHolder.toggleClass("truncated");
  $(this).hide();
}

readMore.click(toggleText);

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setQuizCompletedAttributeToCart(quiz_completed_value) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        '_quiz_completed': quiz_completed_value
      }
    })
  })
  .then(response => response.json());
}

function addQuizCompletionToCart() {
  var quiz_completed = getCookie('quiz_completed');
  var quiz_completed_value = null;
  if (quiz_completed) {
    quiz_completed_value = 'yes';
  }
  setQuizCompletedAttributeToCart(quiz_completed_value);
}

document.addEventListener('quizKitResultsPageLoaded', function (e) {  
  setCookie('quiz_completed', 'yes', 7);
  setQuizCompletedAttributeToCart('yes');
}, false);

// Call the function when the cart changes
document.addEventListener('rebuy:cart.add', addQuizCompletionToCart);



// Product Media Thumbs
const productMediaArrows = document.querySelectorAll('.product-media--thumbs__arrow');
const productMediaThumbsContainer = document.querySelectorAll('.product-media--thumbs__wrapper');
const productMediaThumbs = document.querySelectorAll('.product-media--thumb-container .product-media--thumb');
const productMediaWrapper = document.querySelector('.product-media--wrapper');
let productMediaParent = document.querySelector('.product-page--media');
const productMedia = productMediaWrapper.querySelectorAll('.product-media--featured');


productMediaThumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
    scrollToActiveThumb();
    if(window.innerWidth < 768) {
      scrollToTop(productMediaParent);
    }
  });
});

const mediaControls = () => {
  productMediaArrows.forEach(arrow => {
    const arrowControl = arrow.dataset.control;
    arrow.addEventListener('click', () => {

      toggleActiveThumb(arrowControl);
      scrollToActiveThumb();
      if(window.innerWidth < 768) {
        scrollToTop(productMediaParent);
      }
    });
  });
}
const toggleActiveThumb = (arrowControl) => {
  let activeThumb = Array.from(productMediaThumbs).find(thumb => thumb.dataset.active === "true");
  if (!activeThumb) return;

  let activeThumbContainer = activeThumb.closest('.product-media--thumb-container');

  let newThumbContainer;
  if (arrowControl === "next") {
    // if last element, go to first
    if (!activeThumbContainer.nextElementSibling) {
      newThumbContainer = activeThumbContainer.parentElement.firstElementChild;
    } else {
      newThumbContainer = activeThumbContainer.nextElementSibling;
    }
  } else if (arrowControl === "previous") {
    // if first element, go to last
    if (!activeThumbContainer.previousElementSibling) {
      newThumbContainer = activeThumbContainer.parentElement.lastElementChild;
    } else {
      newThumbContainer = activeThumbContainer.previousElementSibling;
    }
  }

  if (newThumbContainer && newThumbContainer.querySelector('.product-media--thumb')) {
    let newThumb = newThumbContainer.querySelector('.product-media--thumb');
    console.log(newThumb, 'new active thumb');
    updateActiveThumb(newThumb);
    updateActiveFeatured(newThumb.dataset.id);
    pauseVideoOnSwitch();
  }
}
const updateActiveThumb = (newActiveThumb) => {
  productMediaThumbs.forEach(thumb => {
    thumb.dataset.active = "false";
  });
  newActiveThumb.dataset.active = "true";
  newActiveThumb.click();
}


const updateActiveFeatured = (activeThumbId) => {
  productMedia.forEach(featured => {
    if (featured.dataset.id === activeThumbId) {
      featured.dataset.active = "true";
    } else {
      featured.dataset.active = "false";
    }
  });
}

const pauseVideoOnSwitch = () => {
  productMedia.forEach(featured => {
    const videoElement = featured.querySelector('video');
    if (videoElement) {
      if (featured.dataset.mediaType === "video" && featured.dataset.active === "false") {
        videoElement.pause();
      } else if (featured.dataset.mediaType === "video" && featured.dataset.active === "true") {
        videoElement.play();
      }
    }
  });
}



const scrollToActiveThumb = () => {
  let activeThumb = Array.from(productMediaThumbs).find(thumb => thumb.dataset.active === "true");
  if (!activeThumb) return;

  let activeThumbContainer = activeThumb.closest('.product-media--thumb-container');
  activeThumbContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function scrollToTop(element) {
  const elementRect = element.getBoundingClientRect();
  const isInView = (
    elementRect.top >= 0 &&
    elementRect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );

  if (!isInView) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio < 1) { // 30% out of view
          const offset = window.innerHeight * 0.1; // 10% of the viewport height
          const elementTop = element.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: elementTop, behavior: 'smooth' });
          observer.disconnect(); // Stop observing after the first scroll
        }
      });
    }, { threshold: [1] });

    observer.observe(element);
  }
}
mediaControls();



